import React, { useContext } from "react";

import { REACT_APP_API_URL } from "@/env";

export const getClients = (hostname: string) => ({
  authenticationServiceClient: async () => {
    const { AuthenticationServiceClient } = await import(
      "@travello/grpc-api/js/authenticate_grpc_web_pb"
    );

    return new AuthenticationServiceClient(hostname, null, null);
  },
  authenticationServicePromiseClient: async () => {
    const { AuthenticationServicePromiseClient } = await import(
      "@travello/grpc-api/js/authenticate_grpc_web_pb"
    );

    return new AuthenticationServicePromiseClient(hostname, null, null);
  },
  userEditServiceClient: async () => {
    const { UserEditServiceClient } = await import(
      "@travello/grpc-api/js/user_grpc_web_pb"
    );

    return new UserEditServiceClient(hostname, null, null);
  },
  userEditServicePromiseClient: async () => {
    const { UserEditServicePromiseClient } = await import(
      "@travello/grpc-api/js/user_grpc_web_pb"
    );

    return new UserEditServicePromiseClient(hostname, null, null);
  },
  userServiceClient: async () => {
    const { UserServiceClient } = await import(
      "@travello/grpc-api/js/user_grpc_web_pb"
    );
    return new UserServiceClient(hostname, null, null);
  },
  userServicePromiseClient: async () => {
    const { UserServicePromiseClient } = await import(
      "@travello/grpc-api/js/user_grpc_web_pb"
    );
    return new UserServicePromiseClient(hostname, null, null);
  },
  sessionServiceClient: async () => {
    const { SessionServiceClient } = await import(
      "@travello/grpc-api/js/user_grpc_web_pb"
    );

    return new SessionServiceClient(hostname, null, null);
  },
  sessionServicePromiseClient: async () => {
    const { SessionServicePromiseClient } = await import(
      "@travello/grpc-api/js/user_grpc_web_pb"
    );

    return new SessionServicePromiseClient(hostname, null, null);
  },
  feedServiceClient: async () => {
    const { FeedServiceClient } = await import(
      "@travello/grpc-api/js/feed_grpc_web_pb"
    );

    return new FeedServiceClient(hostname, null, null);
  },
  feedServicePromiseClient: async () => {
    const { FeedServicePromiseClient } = await import(
      "@travello/grpc-api/js/feed_grpc_web_pb"
    );

    return new FeedServicePromiseClient(hostname, null, null);
  },
  userSocialServiceClient: async () => {
    const { UserSocialServiceClient } = await import(
      "@travello/grpc-api/js/user_grpc_web_pb"
    );
    return new UserSocialServiceClient(hostname, null, null);
  },
  userSocialServicePromiseClient: async () => {
    const { UserSocialServicePromiseClient } = await import(
      "@travello/grpc-api/js/user_grpc_web_pb"
    );
    return new UserSocialServicePromiseClient(hostname, null, null);
  },
  productServiceClient: async () => {
    const { ProductServiceClient } = await import(
      "@travello/grpc-api/js/product_grpc_web_pb"
    );

    return new ProductServiceClient(hostname, null, null);
  },
  productServicePromiseClient: async () => {
    const { ProductServicePromiseClient } = await import(
      "@travello/grpc-api/js/product_grpc_web_pb"
    );

    return new ProductServicePromiseClient(hostname, null, null);
  },
});

const ApiServicesContext = React.createContext<ReturnType<
  typeof getClients
> | null>(null);

export const ApiServicesProvider: React.FC = ({ children }) => {
  const clients = getClients(REACT_APP_API_URL);

  return (
    <ApiServicesContext.Provider value={clients}>
      {children}
    </ApiServicesContext.Provider>
  );
};

export const useApiServiceClient = () => {
  const value = useContext(ApiServicesContext);
  if (!value) {
    throw Error("ApiServiceContext is not set");
  }
  return value;
};
